<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.25 5.414A3.755 3.755 0 0 0 10 9.164a3.755 3.755 0 0 0 3.75-3.75A3.755 3.755 0 0 0 10 1.664a3.755 3.755 0 0 0-3.75 3.75ZM17.5 17.497v-.833a5.84 5.84 0 0 0-5.833-5.833H8.333A5.84 5.84 0 0 0 2.5 16.664v.833h15Z"
    fill="#111"
    fill-opacity=".64"
  />
</svg>
